import { apiGet, apiPost, apiUpdate } from "../http";

export default {
  async getAllSupplyOrdersAPI() {
    return await apiGet("api/supply");
  },
  async addSupplyOrderAPI(data) {
    return await apiPost("/api/supply", data);
  },
  async editSupplyOrderAPI(data) {
    return await apiUpdate("/api/supply/" + data[0], data[1], {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  async changeSOStateAPI(data) {
    return await apiPost("/api/supply/state", data)
  },
  async deleteSOFileAPI(data) {
    return await apiPost("/api/supply/fileDelete", data)
  },
  async downloadSupplyFileAPI(data) {
    return await apiPost("/api/supply/file", data, { responseType: "arraybuffer" })
  }
};
